/**
 * Component Class
 */
export class Component<THTMLElement extends HTMLElement = HTMLElement> {
  static isShared = false;
  public element: THTMLElement | null = null;
  private handlers: Map<any, any> = new Map();
  protected _isShared = false;

  // 全ページで共通のコンポーネント
  // ページ遷移してもunmount / destroyされないコンポーネント
  public get isShared() {
    return this._isShared;
  }

  // HTMLElementに接続する
  public mount(element: THTMLElement | null) {
    this.element = element;
    if (!this.element) {
      throw new ReferenceError('element is not found.');
    }
    if (this.element) {
      this.didMount();
    }
  }

  public destroy() {
    this.removeAllEventListeners();
    this.didUnmount();
    this.element = null;
  }

  public emit(type: string) {
    let event: Event | null;

    if (typeof Event === 'function') {
      event = new Event(type);
    } else {
      event = document.createEvent('Event');
      event.initEvent(type, true, true);
    }
    this.element?.dispatchEvent(event);
  }

  public on(type: string, handler: (args?: any) => any) {
    this.handlers.set(handler, type);
    if (!this.element) {
      throw new Error('element is undefined.');
    }
    this.element?.addEventListener(type, handler);
  }

  public off(type: string, handler: (args?: any) => void) {
    if (handler) {
      this.handlers.delete(handler);
      this.element?.removeEventListener(type, handler);
    } else {
      this.removeAllEventListeners(type);
    }
  }

  public removeAllEventListeners(type?: string) {
    const remove: any[] = [];
    this.handlers.forEach((t, h) => {
      if (!type || (type && t === type)) {
        this.element?.removeEventListener(t, h);
        remove.push(h);
      }
    });
    remove.map((r) => {
      this.handlers.delete(r);
    });
  }

  // HTMLElementに接続されたコールバック関数
  protected didMount(): void {}

  // HTMLElementから切断される前のコールバック関数
  public willUnmount(): void {}

  // HTMLElementから切断されたコールバック関数
  public didUnmount(): void {}
}
